import React, {useEffect, useState} from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import './Answer.css';
import {Typography} from "@mui/material";
import Loading from '../../Loading/CodeLoading';

const Answer = ({ content,key }) => {
    const [showLoading, setShowLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowLoading(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, [key]);
    const renderTestCases = () => {
        if (content.language === 'sql') {
            const testCaseData = content.testCases[0];
            if (!testCaseData || typeof testCaseData !== 'object') {
                return <p>No valid test case data available.</p>;
            }

            const renderTable = (data) => {
                return Object.entries(data).map(([tableName, tableData]) => {
                    const columns = Object.keys(tableData);
                    const rowCount = tableData[columns[0]].length;
                    return (
                        <div key={tableName}>
                            <table className="test-case-table">
                                <thead>
                                    <tr>
                                        {columns.map((column, index) => (
                                            <th key={index}>{column}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...Array(rowCount)].map((_, rowIndex) => (
                                        <tr key={rowIndex}>
                                            {columns.map((column, colIndex) => (
                                                <td key={colIndex}>{tableData[column][rowIndex]}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    );
                });
            };

            return (
                <div>
                     <h3 style={{ textAlign: 'left' }}>Input: Products</h3>
    {renderTable(testCaseData.input)}
    <h3 style={{ textAlign: 'left' }}>Expected Output: Result</h3>
    {renderTable(testCaseData.output)}
                </div>
            );
        } else {
            return (
                <table className="test-case-table">
                    <thead>
                        <tr>
                            <th>Test Case</th>
                            <th>Input</th>
                            <th>Output</th>
                        </tr>
                    </thead>
                    <tbody>
                        {content.testCases.map((tc, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                    <pre>{JSON.stringify(tc.input, null, 2)}</pre>
                                </td>
                                <td>
                                    <pre>{JSON.stringify(tc.output, null, 2)}</pre>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        }
    };

   const renderContent = () => (
        <div className="live-coding-pane">
            <div className="header-container">
                <div className="icon-left">
                </div>
                <Typography variant="h6" component="h3" className="copilot-title">
                    Live-Coding
                </Typography>
            </div>
            <div className="coding-copilot">
                <div className="parent-container">
                    <div className="algorithm-analysis">
                        <h3>Algorithm Analysis</h3>
                        <div dangerouslySetInnerHTML={{ __html: content.analysis }} />
                        {content.language !== 'sql' && (
                            <div className="complexity">
                                <p><strong>Time Complexity:</strong> {content.timeComplexity}</p>
                                <p><strong>Space Complexity:</strong> {content.spaceComplexity}</p>
                            </div>
                        )}
                    </div>
                    <div className="code-section">
                        <h3>Code Preview</h3>
                        <div className="code-display">
                            <SyntaxHighlighter
                                language={content.language}
                                style={darcula}
                                customStyle={{
                                    fontSize: '12px',
                                }}
                                wrapLongLines={true}
                            >
                                {content.code}
                            </SyntaxHighlighter>
                        </div>
                        <div className="testcase-section">
                            <h3>Test Cases</h3>
                            {renderTestCases()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return showLoading ? <Loading /> : renderContent();
};

export default Answer;